import { useState, useEffect } from "react";
import Login from "./auth/login";
import CheckLoginStatus from "./auth/check-login-status";
import CallList from "./call-list";
import Home from "./home";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { storage } from "./utils/storage";
import CallInsight from "./call-insight";
import TranscriptionAudit from "./call-insight/transcription_audit";
import Leads from "./opportunities";
import ServiceRequests from "./service-requests";
import ArchiveCall from "./archive-call";
import DeepAnalysis from "./deep-analysis";
import Contact from "./contact";
import LeadDetails from "./opportunity-details";
import PromiseDetails from "./promise-details";
import SRDetails from "./service-request-details";
import ManageUser from "./user-management/manage-user";
import ManageRole from "./user-management/manage-role";
import AppFeature from "./user-management/app-feature";
import CustomerIntentReport from "./reports/customer-intent";
import ProductIntentReport from "./reports/product-intent";
import CXScoreTrendReport from "./reports/cx-score-trend";
import ManagerReviewReport from "./reports/mamager-review";
import OpportunityReport from "./reports/opportunity";
import ServiceRequestReport from "./reports/service-request";
import CollectionReport from "./reports/collection";
import Performance from "./reports/performance";
import Task from "./My things/task";
import MyThing from "./My things/my-thing";
import MyThingsQualityAudit from "./My things/quality-audit";
import MyThingsCollectionStrategy from "./My things/collection-strategy";
import ContactDetail from "./contact-detail";
import LiveCall from "./live-call";
import Account from "./account";
import QualityHome from "./quality/quality-home";
import DashboardHome from "./reports/dashboard/home";
import ComplianceReport from "./reports/compliance";
import Equity from "./reports/equity";
import Mutual from "./reports/mutual";
import Forex from "./reports/forex";
import Criticalbusiness from "./reports/audit/criticalbusiness";
import Criticalcustomer from "./reports/audit/criticalcustomer";
import Criticalregulatory from "./reports/audit/criticalregulatory";
import Outputdatabase from "./reports/audit/outputdatabase";
import Noncritical from "./reports/audit/noncritical";
import PageNotFound from "./pagenotfound";
import ComplaintsInsight from "./complaintsManagement/complaintsInsight";
import ComplaintsDeepAnalysis from "./complaintsManagement/complaintDeepAnalysis";
import TicketList from "./complaintsManagement/ticketlist";
import ComplaintsServiceRequest from "./complaintsManagement/complaintsServiceRequest";
import ComplaintsArchived from "./complaintsManagement/complaintsArchived";
import Report from "./reports/mayaBank/report";
import Promisetopay from "./promisetopay/promisetopay";
import Promispay from "./reports/promistopay";
import Agentscorecard from "./reports/agent-scorecard";
import AgentInsight from "./reports/agent-insight";
import Hdfcdreport from "../src/hdfcdigitals/report";
import Detailedreport from "./reports/mayaBank/detailed-report";
import Predue from "./reports/mayaBank/predue";
import Latedue from "./reports/mayaBank/latedue";
import Postduegreater from "./reports/mayaBank/postduegreater";
import Postdueless from "./reports/mayaBank/postdueless";
import Deviance from "./reports/mayaBank/deviance";
import Editreport from "./reports/mayaBank/edit-report";
import Revisedreport from "./reports/mayaBank/revised-report";
import Myreport from "./reports/my-report";
import Myreportdetail from "./reports/my-report-detail";
import Savedreportdetail from "./reports/saved-report-details";
import PostDueGreaterDetail from "./reports/mayaBank/postduegreater-detailed";
import PostDueLessDetail from "./reports/mayaBank/postdueless-details";
import LateDueDetail from "./reports/mayaBank/latedue-detail";
import Accesslog from "./reports/mayaBank/access-log";
import Maintainence from "./maintainence";
// import useMaintenanceStatus from "./Hooks/useMaintenanceStatus";
import Service from "./webservice/http";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import config from "./config";
import EconomicNewsCards from "./Economicnewscards";
import { useLogout } from "./Hooks/useLogout";
import logout from "./utils/logout";
import Recovery from "./reports/recovery";
import CollectionStrategy from "./reports/Collection Strategy/collectionStrategy";
import Detail from "./reports/Collection Strategy/detail";
import TranscriptionAuditReport from "./reports/Transcription Audit/transcription-audit";
import LobHome from "./hierarchy/home";
import ProductIntentReportAll from "./reports/product-intent-all";
import CXScoreTrendReportAll from "./reports/cx-score-trend-all";
import CustomerIntentReportAll from "./reports/customer-intent-all";
import CallTranscriptionAudit from "./call-insight/call-transcription-audit";

function App() {
  /**
   * Application Initialization Point
   *
   * Navigate to different Components based on router link
   */
  const { loginStatus } = CheckLoginStatus();
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useLogout(logout, loginStatus);

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        const response = await axios.get(
          `${config.API_BASE_URL}/api/access_control/maintenance/`,
        );
        const data = await response?.data?.is_active;
        setIsMaintenance(data);
        // console.log("Maintenance Status Response:", response);
      } catch (error) {
        console.error("Failed to fetch maintenance status:", error);
        setIsMaintenance(false);
      } finally {
        setIsLoading(false);
      }
    };
    checkMaintenance();
  }, []);

  if (isLoading) {
    return (
      <div
        style={{
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <ClipLoader color="#2056FF" size="50px" />
      </div>
    );
  }

  if (isMaintenance) {
    return <Maintainence />;
  }

  return (
    <Router>
      <div className="App">
        <Switch>
          <Route exact path="/">
            <Home loginStatus={loginStatus} />
          </Route>
          <Route exact path="/lob-home">
            <LobHome loginStatus={loginStatus} />
          </Route>
          <Route exact path="/login">
            <Login loginStatus={loginStatus} />
          </Route>
          <Route exact path="/call-list">
            <CallList loginStatus={loginStatus} />
          </Route>
          <Route exact path="/ticket-list">
            <TicketList loginStatus={loginStatus} />
          </Route>
          <Route exact path="/call/:callID/call-insight">
            <CallInsight loginStatus={loginStatus} />
          </Route>
          <Route exact path="/call/:callID/transcription-audit">
            <TranscriptionAudit loginStatus={loginStatus} />
          </Route>
          <Route exact path="/ticket/:callID/complaints-insight">
            <ComplaintsInsight loginStatus={loginStatus} />
          </Route>
          <Route exact path="/call/:callID/call-transcription-audit">
            <CallTranscriptionAudit loginStatus={loginStatus} />
          </Route>
          <Route exact path="/call/:callID/deep-analysis">
            <DeepAnalysis loginStatus={loginStatus} />
          </Route>
          <Route exact path="/ticket/:callID/deep-analysis">
            <ComplaintsDeepAnalysis loginStatus={loginStatus} />
          </Route>
          <Route exact path="/call/opportunities">
            <Leads loginStatus={loginStatus} />
          </Route>
          <Route exact path="/call/call-status">
            <Promisetopay loginStatus={loginStatus} />
          </Route>
          <Route exact path="/call/:leadID/opportunity-details">
            <LeadDetails loginStatus={loginStatus} />
          </Route>
          <Route exact path="/call/:leadID/call-status-details">
            <PromiseDetails loginStatus={loginStatus} />
          </Route>
          <Route exact path="/call/service-requests">
            <ServiceRequests loginStatus={loginStatus} />
          </Route>
          <Route exact path="/ticket/service-requests">
            <ComplaintsServiceRequest loginStatus={loginStatus} />
          </Route>
          <Route exact path="/call/:srID/sr-details">
            <SRDetails loginStatus={loginStatus} />
          </Route>
          <Route exact path="/call/archive-calls">
            <ArchiveCall loginStatus={loginStatus} />
          </Route>
          <Route exact path="/ticket/archive-tickets">
            <ComplaintsArchived loginStatus={loginStatus} />
          </Route>
          <Route exact path="/contact">
            <Contact loginStatus={loginStatus} />
          </Route>
          <Route exact path="/contact/:contactId">
            <ContactDetail loginStatus={loginStatus} />
          </Route>
          <Route exact path="/user-management/manage-user">
            <ManageUser loginStatus={loginStatus} />
          </Route>
          <Route exact path="/user-management/manage-role">
            <ManageRole loginStatus={loginStatus} />
          </Route>
          <Route exact path="/user-management/app-feature">
            <AppFeature loginStatus={loginStatus} />
          </Route>
          <Route exact path="/reports/customer-intent">
            <CustomerIntentReport loginStatus={loginStatus} />
          </Route>
          <Route exact path="/reports/product-intent">
            <ProductIntentReport loginStatus={loginStatus} />
          </Route>
          <Route exact path="/reports/customer-intent-all">
            <CustomerIntentReportAll loginStatus={loginStatus} />
          </Route>
          {/* this route for all the other usecases */}
          <Route exact path="/reports/product-intent-all">
            <ProductIntentReportAll loginStatus={loginStatus} />
          </Route>

          <Route exact path="/reports/forex">
            <Forex />
          </Route>
          <Route exact path="/reports/equity">
            <Equity />
          </Route>
          <Route exact path="/reports/mutual">
            <Mutual />
          </Route>
          <Route exact path="/reports/reports-dashboard">
            <Hdfcdreport />
          </Route>
          <Route exact path="/reports/agent-scorecard/:id">
            <AgentInsight />
          </Route>
          <Route exact path="/reports/agent-scorecard">
            <Agentscorecard />
          </Route>
          <Route exact path="/reports/criticalbusiness">
            <Criticalbusiness />
          </Route>
          <Route exact path="/reports/criticalcustomer">
            <Criticalcustomer />
          </Route>
          <Route exact path="/reports/noncritical">
            <Noncritical />
          </Route>
          <Route exact path="/reports/criticalregulatory">
            <Criticalregulatory />
          </Route>
          <Route exact path="/reports/dashboard">
            <Outputdatabase />
          </Route>
          <Route exact path="/reports">
            <Report />
          </Route>
          {/* collection strategy */}
          <Route exact path="/reports/collection-strategy">
            <CollectionStrategy />
          </Route>
          <Route exact path="/reports/detail/:id/collection-strategy">
            <Detail />
          </Route>

          <Route exact path="/reports/my-reports">
            <Myreport />
          </Route>
          <Route exact path="/access-logs">
            <Accesslog />
          </Route>
          <Route exact path="/reports/my-reports-details">
            <Myreportdetail />
          </Route>
          <Route exact path="/reports/saved-reports-details/:id">
            <Savedreportdetail />
          </Route>
          <Route exact path="/reports/promise-to-pay">
            <Promispay loginStatus={loginStatus} />
          </Route>
          <Route exact path="/detailed-reports/:id">
            <Detailedreport />
          </Route>
          <Route exact path="/postduegreater-detail/:id">
            <PostDueGreaterDetail />
          </Route>
          <Route exact path="/postdueless-detail/:id">
            <PostDueLessDetail />
          </Route>
          <Route exact path="/latedue-detail/:id">
            <LateDueDetail />
          </Route>
          <Route exact path="/reports/predue">
            <Predue />
          </Route>
          <Route exact path="/reports/latedue">
            <Latedue />
          </Route>
          <Route exact path="/reports/postgreater">
            <Postduegreater />
          </Route>
          <Route exact path="/reports/postless">
            <Postdueless />
          </Route>
          <Route exact path="/reports/deviance-analysis">
            <Deviance />
          </Route>
          <Route exact path="/edit-report/:id">
            <Editreport />
          </Route>
          <Route exact path="/report/revised-report/:id">
            <Revisedreport />
          </Route>
          <Route exact path="/reports/cx-score-trend">
            <CXScoreTrendReport loginStatus={loginStatus} />
          </Route>
          {/* cx score for all usecase */}
          <Route exact path="/reports/cx-score-trend-all">
            <CXScoreTrendReportAll loginStatus={loginStatus} />
          </Route>

          <Route exact path="/reports/manager-review">
            <ManagerReviewReport loginStatus={loginStatus} />
          </Route>
          <Route exact path="/reports/opportunity">
            <OpportunityReport loginStatus={loginStatus} />
          </Route>
          <Route exact path="/reports/ptp">
            <Recovery loginStatus={loginStatus} />
          </Route>
          <Route exact path="/reports/service-request">
            <ServiceRequestReport loginStatus={loginStatus} />
          </Route>
          <Route exact path="/reports/collection">
            <CollectionReport loginStatus={loginStatus} />
          </Route>
          <Route exact path="/reports/performance">
            <Performance loginStatus={loginStatus} />
          </Route>
          <Route exact path="/reports/compliance">
            <ComplianceReport loginStatus={loginStatus} />
          </Route>
          <Route exact path="/reports/transcription-report">
            <TranscriptionAuditReport loginStatus={loginStatus} />
          </Route>

          <Route
            exact
            path="/my-things"
            render={() => {
              const username = storage.getItem("username");
              if (username === "MYABCMR01" || username === "MYABCQT01") {
                return <Redirect to="/my-things/my-thing" />;
              } else if (username === "MYABCNG01" || username === "GNLNNT01") {
                return <Redirect to="/my-things/collection-strategy" />;
              } else {
                return <Redirect to="/my-things/task" />;
              }
            }}
          />
          <Route exact path="/my-things/task">
            <Task loginStatus={loginStatus} />
          </Route>
          <Route exact path="/my-things/my-thing">
            <MyThing loginStatus={loginStatus} />
          </Route>
          <Route exact path="/my-things/transcriptionaudit">
            <MyThingsQualityAudit loginStatus={loginStatus} />
          </Route>
          <Route exact path="/my-things/collection-strategy">
            <MyThingsCollectionStrategy loginStatus={loginStatus} />
          </Route>
          <Route exact path="/live-call">
            <LiveCall />
          </Route>
          <Route exact path="/account">
            <Account />
          </Route>
          <Route exact path="/quality-audit">
            <QualityHome />
          </Route>
          <Route exact path="/dashboard">
            <DashboardHome />
          </Route>
          <Route exact path="/media-advisory">
            <EconomicNewsCards />
          </Route>
          <Route path="*" component={PageNotFound} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
